import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { API_BASE } from "@/lib/api";

export default function LegalDoc() {
  const { kind } = useParams();
  const { i18n } = useTranslation();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const lang = i18n.language?.split("-")[0] || "en";
  const isRtl = lang === "ar";

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_BASE}/legal/${kind}?lang=${lang}`)
      .then(({ data }) => setDoc(data))
      .finally(() => setLoading(false));
  }, [kind, lang]);

  return (
    <div
      className="min-h-screen bg-slate-50 py-12"
      dir={isRtl ? "rtl" : "ltr"}
      data-testid="legal-page"
    >
      <div className="mx-auto max-w-3xl px-4">
        <Link to="/" className="text-sm text-indigo-700 hover:underline">
          ← InvoicePro
        </Link>
        <article
          className="mt-4 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm prose prose-slate max-w-none prose-headings:font-heading prose-h1:text-3xl prose-h2:text-lg prose-h2:mt-6 prose-a:text-indigo-700"
          data-testid="legal-body"
        >
          {loading ? (
            <div className="text-slate-500">…</div>
          ) : doc?.html ? (
            <div dangerouslySetInnerHTML={{ __html: doc.html }} />
          ) : (
            <>
              <h1>{doc?.title}</h1>
              <p className="whitespace-pre-wrap text-slate-700">{doc?.body}</p>
            </>
          )}
        </article>
        {doc?.updated_at && (
          <p className="mt-4 text-center text-xs text-slate-400">
            Updated: {doc.updated_at}
          </p>
        )}
      </div>
    </div>
  );
}
